var desktops = document.querySelectorAll('.desktop'),
    teams_selector = document.querySelector('#teams_selector');

// A function that will allow users to swap between seasons.
function season_swap() {
  $(document).ready(function(){
    // Hide season 1 and display season 2 first.
    $('.season1-team').hide();

    $('#team_list .season--1').on('click', function(){
       $('.season2-team').hide();
       $('.season1-team').show();
       hideAll();
       show(document.getElementById('slide-5'));
       $('#team_list li').removeClass('current')
       $(this).addClass('current');
       focusSelectedSeason(this);
    })

    $('#team_list .season--2').on('click', function(){
       $('.season2-team').show();
       $('.season1-team').hide();
       hideAll();
       show(document.getElementById('slide-0'));
       $('#team_list li').removeClass('current')
       $(this).addClass('current');
       focusSelectedSeason(this);
    })

    // Add event listener for Enter key on season swap options
    $('#team_list .season--1, #team_list .season--2').on('keypress', function(event){
      if (event.key === "Enter") {
        if ($(this).hasClass('season--1')) {
          // Switch to season 1
          $('.season2-team').hide();
          $('.season1-team').show();
          hideAll();
          show(document.getElementById('slide-5'));
          $('#team_list li').removeClass('current')
          $(this).addClass('current');
          focusSelectedSeason(this);
        } else if ($(this).hasClass('season--2')) {
          // Switch to season 2
          $('.season2-team').show();
          $('.season1-team').hide();
          hideAll();
          show(document.getElementById('slide-0'));
          $('#team_list li').removeClass('current')
          $(this).addClass('current');
          focusSelectedSeason(this);
        }
      }
    });
  });
}

season_swap();

// Hides the slides next to the team roster navigation menu.
function hide(element) {
  if ($(window).width() > 767) { 
    element.style.setProperty('left', '-100%', element.style.getPropertyPriority('left'));
  } else {
    element.style.setProperty('display', 'none', element.style.getPropertyPriority('display'));
    element.style.setProperty('top', '-100%', element.style.getPropertyPriority('top'));
  }
}

// Hides all slides.
function hideAll() {
  for (var i = 0; i < desktops.length; i++) {
    hide(desktops[i]);
    $(desktops[i]).attr("aria-selected", "false");
  }
}

// Shows one slide.
function show(element) {
  if ($(window).width() > 767) { 
    element.style.setProperty('left', '0', element.style.getPropertyPriority('left'));
  } else {
    element.style.setProperty('display', 'block', element.style.getPropertyPriority('display'));
    element.style.setProperty('top', '0', element.style.getPropertyPriority('top'));
  }
} 

// Tablet and desktop slider settings

 /***** Slide 1 *****/
document.getElementById('link-0').addEventListener('click', function () {
  hideAll();
  show(document.getElementById('slide-0'));
}, false);

document.getElementById('link-0').addEventListener('keypress', function () {
  if(event.key === "Enter") {
     hideAll();
     show(document.getElementById('slide-0')); 
     document.getElementById('slide-0').setAttribute("aria-selected", "true");
  }
}, false);

  /***** Slide 2 *****/
document.getElementById('link-1').addEventListener('click', function () {
  hideAll();
  show(document.getElementById('slide-1'));
  document.getElementById('slide-1').setAttribute("aria-selected", "true");
}, false);

document.getElementById('link-1').addEventListener('keypress', function () {
  if(event.key === "Enter") {
     hideAll();
     show(document.getElementById('slide-1'));
     document.getElementById('slide-1').setAttribute("aria-selected", "true");
  }
}, false);

  /***** Slide 3 *****/
document.getElementById('link-2').addEventListener('click', function () {
  hideAll();
  show(document.getElementById('slide-2'));
  document.getElementById('slide-2').setAttribute("aria-selected", "true");
}, false);

document.getElementById('link-2').addEventListener('keypress', function () {
  if(event.key === "Enter") {
     hideAll();
     show(document.getElementById('slide-2')); 
     document.getElementById('slide-2').setAttribute("aria-selected", "true");
  }
}, false);

  /***** Slide 4 *****/
document.getElementById('link-3').addEventListener('click', function () {
  hideAll();
  show(document.getElementById('slide-3'));
  document.getElementById('slide-3').setAttribute("aria-selected", "true");
}, false);

document.getElementById('link-3').addEventListener('keypress', function () {
  if(event.key === "Enter") {
     hideAll();
     show(document.getElementById('slide-3')); 
     document.getElementById('slide-3').setAttribute("aria-selected", "true");
  }
}, false);

  /***** Slide 5 *****/
document.getElementById('link-4').addEventListener('click', function () {
  hideAll();
  show(document.getElementById('slide-4'));
  document.getElementById('slide-4').setAttribute("aria-selected", "true");
}, false);

document.getElementById('link-4').addEventListener('keypress', function () {
  if(event.key === "Enter") {
     hideAll();
     show(document.getElementById('slide-4')); 
     document.getElementById('slide-4').setAttribute("aria-selected", "true");
  }
}, false);

/***** Slide 6 *****/
document.getElementById('link-5').addEventListener('click', function () {
  hideAll();
  show(document.getElementById('slide-5'));
  document.getElementById('slide-5').setAttribute("aria-selected", "true");
}, false);

document.getElementById('link-5').addEventListener('keypress', function () {
  if(event.key === "Enter") {
     hideAll();
     show(document.getElementById('slide-5')); 
     document.getElementById('slide-5').setAttribute("aria-selected", "true");
  }
}, false);

  /***** Slide 7 *****/
document.getElementById('link-6').addEventListener('click', function () {
  hideAll();
  show(document.getElementById('slide-6'));
  document.getElementById('slide-6').setAttribute("aria-selected", "true");
}, false);

document.getElementById('link-6').addEventListener('keypress', function () {
  if(event.key === "Enter") {
     hideAll();
     show(document.getElementById('slide-6'));
     document.getElementById('slide-6').setAttribute("aria-selected", "true");
  }
}, false);

  /***** Slide 8 *****/
document.getElementById('link-7').addEventListener('click', function () {
  hideAll();
  show(document.getElementById('slide-7'));
  document.getElementById('slide-7').setAttribute("aria-selected", "true");
}, false);

document.getElementById('link-7').addEventListener('keypress', function () {
  if(event.key === "Enter") {
     hideAll();
     show(document.getElementById('slide-7'));
     document.getElementById('slide-7').setAttribute("aria-selected", "true");
  }
}, false);

  /***** Slide 9 *****/
document.getElementById('link-8').addEventListener('click', function () {
  hideAll();
  show(document.getElementById('slide-8'));
  document.getElementById('slide-8').setAttribute("aria-selected", "true");
}, false);

document.getElementById('link-8').addEventListener('keypress', function () {
  if(event.key === "Enter") {
     hideAll();
     show(document.getElementById('slide-8'));
     document.getElementById('slide-8').setAttribute("aria-selected", "true");
  }
}, false);

  /***** Slide 10 *****/
document.getElementById('link-9').addEventListener('click', function () {
  hideAll();
  show(document.getElementById('slide-9'));
  document.getElementById('slide-9').setAttribute("aria-selected", "true");
}, false);

document.getElementById('link-9').addEventListener('keypress', function () {
  if(event.key === "Enter") {
     hideAll();
     show(document.getElementById('slide-9'));
     document.getElementById('slide-9').setAttribute("aria-selected", "true");
  }
}, false);

// Display the first team slide of season 2.
show(document.getElementById('slide-0'));